
import React from 'react';
import styles from './BetaIndicator.module.css'; // Assuming you have a CSS module for styling

const BetaIndicator = () => (
  <div className={styles.betaIndicator}>
    <p>stackFrame is currently in beta.</p>
  </div>
);

export default BetaIndicator;
